import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {
  values = [
    {
      icon: 'precision_manufacturing',
      title: 'Engineering Precision',
      description: 'We build software the way architects build structures — with rigorous standards, clean layers, and zero tolerance for ambiguity.'
    },
    {
      icon: 'diversity_3',
      title: 'Customer-First Culture',
      description: 'Every feature we ship starts with a real problem from a real customer. We listen deeply before we build.'
    },
    {
      icon: 'school',
      title: 'Continuous Mastery',
      description: 'Our team is obsessed with improvement. We invest in learning, certifications, and staying ahead of the industry curve.'
    },
    {
      icon: 'handshake',
      title: 'Long-Term Partnership',
      description: "We don't just sell software — we build relationships. Your success is our success, measured in years, not transactions."
    }
  ];

  milestones = [
    { year: '2018', event: 'ZAD ERP Founded', detail: 'Started with a single module and a vision to unify enterprise operations across the Middle East.' },
    { year: '2019', event: 'First 50 Clients', detail: 'Reached our first milestone with businesses in retail, logistics, and professional services.' },
    { year: '2021', event: 'TransArchitect Launched', detail: 'Introduced our specialized vehicle rental and transportation management module.' },
    { year: '2022', event: 'Multi-Country Expansion', detail: 'Expanded to serve businesses in Saudi Arabia, UAE, Bahrain, and Kuwait.' },
    { year: '2023', event: '1,000+ Active Businesses', detail: 'Crossed 1,000 active companies using ZAD ERP as their primary business operating system.' },
    { year: '2024', event: 'Finance Module 2.0', detail: 'Launched ZATCA-compliant e-invoicing and advanced multi-currency reporting for global enterprises.' },
    { year: '2025', event: 'AI-Assisted Workflows', detail: 'Introduced intelligent automation features across CRM, HR, and inventory modules.' }
  ];

  team = [
    {
      name: 'Khalid Al-Rashidi',
      role: 'CEO & Co-Founder',
      bio: '15+ years in enterprise software. Former VP of Engineering at a regional fintech leader.',
      initials: 'KR'
    },
    {
      name: 'Sarah Al-Mansouri',
      role: 'CTO & Co-Founder',
      bio: 'Full-stack architect and cloud systems expert. Built infrastructure serving millions of daily transactions.',
      initials: 'SM'
    },
    {
      name: 'Omar Hafez',
      role: 'Head of Product',
      bio: 'Product leader with deep domain expertise in ERP, CRM, and logistics automation.',
      initials: 'OH'
    },
    {
      name: 'Lina Al-Zahrani',
      role: 'Head of Customer Success',
      bio: 'Passionate about implementation excellence and long-term customer growth. 200+ successful ERP deployments.',
      initials: 'LZ'
    }
  ];
}
